import {
    type OrgEmployeeRequestPatternRequest,
    OrgEmployeeRequestService,
    type OrgEmployeeRequest,
} from '@api/OrgEmployeeRequestService';
import { useApiCall } from '../apiCall';
import { invalidateOrgEmployeeRequestData } from '@stores/orgEmployeeRequestStore';
import { useEffect, useMemo } from 'react';

const useOrgEmployeeRequestPatternUpdate = (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
    orgEmployeeRequestAvailabilityPattern: OrgEmployeeRequestPatternRequest,
): {
    updatedOrgEmployeeRequest: OrgEmployeeRequest | undefined;
    isOrgEmployeeRequestPatternUpdateInProgress: boolean;
    updateOrgEmployeeRequestPattern: () => void;
} => {
    const putParam = useMemo(
        () =>
            [
                orgId,
                orgEmployeeId,
                requestId,
                orgEmployeeRequestAvailabilityPattern,
            ] as const,
        [
            orgId,
            orgEmployeeId,
            requestId,
            orgEmployeeRequestAvailabilityPattern,
        ],
    );

    const {
        response: updatedOrgEmployeeRequest,
        isLoading: isOrgEmployeeRequestPatternUpdateInProgress,
        requestApiCall: updateOrgEmployeeRequestPattern,
    } = useApiCall(
        OrgEmployeeRequestService.putOrgEmployeeRequestPattern,
        [...putParam],
        [...putParam],
        false,
    );

    /*
     * Pattern updates invalidate the cached org employee request
     * data, so the cache never serves the pre-update requests.
     */
    useEffect(() => {
        if (updatedOrgEmployeeRequest !== undefined) {
            invalidateOrgEmployeeRequestData();
        }
    }, [updatedOrgEmployeeRequest]);

    return {
        updatedOrgEmployeeRequest,
        isOrgEmployeeRequestPatternUpdateInProgress,
        updateOrgEmployeeRequestPattern,
    };
};

export default useOrgEmployeeRequestPatternUpdate;
